import React from "react";
import { Container } from "reactstrap";
import { Row } from "reactstrap";
import { Col } from "reactstrap";
import { Link } from "react-router-dom";

const PreloaderData = () => {
  return (
    <div className="page-content">
      <Container fluid>
        <Row align="center" style={{ verticalAlign: "middle" }}>
          <Col xs="12">
            <div className="text-center my-3">
              <Link to="#" className="text-primary">
                <div
                  id="preloader"
                  style={{
                    background: "transparent",
                    zIndex: "1",
                    height: "100%",
                    left: "10%",
                  }}
                >
                  <div id="status">
                    <div className="spinner-chase">
                      <div className="chase-dot"></div>
                      <div className="chase-dot"></div>
                      <div className="chase-dot"></div>
                      <div className="chase-dot"></div>
                      <div className="chase-dot"></div>
                      <div className="chase-dot"></div>
                    </div>
                  </div>
                </div>
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default PreloaderData;
